import { z } from 'zod';
import { DATA_SCOPES } from '../permissions.js';
import { SYSTEM_ROLE_KEYS } from '../role-templates.js';
export const createRoleSchema = z.object({
    name: z.string().trim().min(1).max(100),
    description: z.string().trim().max(300).optional(),
    /** Clone this system role template's grants as the starting point —
     * omitted (or undefined) leaves the new role blank, matching the
     * pre-existing "Add" flow in the roles list. */
    templateKey: z.enum(SYSTEM_ROLE_KEYS).optional(),
});
export const updateRoleSchema = z.object({
    name: z.string().trim().min(1).max(100).optional(),
    description: z.string().trim().max(300).optional(),
    /** The whole grant set, replacing what the role had — the admin UI's
     * permission matrix always submits the complete table
     * (docs/architecture screen "Admin — roles & permissions"). */
    grants: z
        .array(z.object({
        permissionKey: z.string(),
        scope: z.enum(DATA_SCOPES),
    }))
        .optional(),
});
export const roleResponseSchema = z.object({
    id: z.string().uuid(),
    key: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    isSystem: z.boolean(),
    isLocked: z.boolean(),
    memberCount: z.number().int(),
    templateKey: z.enum(SYSTEM_ROLE_KEYS).nullable(),
    templateName: z.string().nullable(),
    lastEditedByName: z.string().nullable(),
    lastEditedAt: z.string().datetime().nullable(),
    grants: z.array(z.object({ permissionKey: z.string(), scope: z.enum(DATA_SCOPES) })),
});
//# sourceMappingURL=roles.js.map